import React from 'react';
import styled from 'styled-components';
// components
import TicketsListContainer from '../ui/containers/ticketsListContainer';
import BasicLoader from '../ui/loaders/basicLoader';
import TicketsListTable from './ticketsListTable/ticketsListTable';
import NotFound from '../ui/icon/notFound';
import DateText from '../ui/texts/DateText';

const NoResultsContainer = styled.div`
  display: flex;
  flex-grow: 1;
  padding-top: 60px;
  align-items: center;
  flex-direction: column;
`;

const t = {
  no_tickets_found: 'No tickets were found that met the criteria',
};

const TicketsList = ({ ticketsListData, className }) => {
  const hasTickets = ticketsListData?.ungroupedTickets?.[0].length > 0;
  return (
    <TicketsListContainer className={className}>
      {ticketsListData.isLoadingTickets ? (
        <BasicLoader />
      ) : hasTickets ? (
        <TicketsListTable ticketsListData={ticketsListData} />
      ) : (
        <NoResultsContainer>
          <NoResultsContainer>
            <NotFound />
            <DateText>{t.no_tickets_found}</DateText>
          </NoResultsContainer>
        </NoResultsContainer>
      )}
    </TicketsListContainer>
  );
};

export default styled(TicketsList)``;
